import {loadStripe} from '@stripe/stripe-js';
//@ts-ignore
import {STRIPE_PUBLIC_API_KEY} from '../../../constants';

const stripePromise = loadStripe(STRIPE_PUBLIC_API_KEY);
export function getStripePromise() {
  return stripePromise;
}
